import shopifyHtmxDefaults from '../shopify-htmx/config.js';

export default {
  ...shopifyHtmxDefaults,
  includes: ['shopify-generic', 'shopify-htmx'],
  SearchRequestDefaults: {
    ...shopifyHtmxDefaults.SearchRequestDefaults,
    extra: {
      ...shopifyHtmxDefaults.SearchRequestDefaults.extra,
      doNotHideWheelsTiresFacets: window.Convermax.Shopify?.getPageType() === 'home',
    },
  },
};
